import { IndicatorFactType, R1FactType } from '@/api/rest/resources/types/fact';
import { GraphTileType } from '@/api/rest/resources/types/widget';

export const availableGraphsToIndicatorNames = {
  [GraphTileType.historic_below_ground_carbon]: R1FactType.permanent_soil_carbon_total,
  [GraphTileType.historic_above_ground_carbon]: R1FactType.above_ground_carbon_total,
  [GraphTileType.historic_water_soil_moisture]: R1FactType.water_fc_total,
  // TODO: MVP-7133 - enable when zoom is added to precipitation soil moisture graph
  // TODO: MVP-7605 - enable when it becames clear whether precipitation soil moisture can be shown at an organization level
  // [GraphTileType.historic_precipitation_soil_moisture]: R1FactType.soil_moisture_smooth_timeseries_total,
  [GraphTileType.social_life_expectancy]: R1FactType.social_life_expectancy,
  [GraphTileType.protected_on_farm_habitat]: R1FactType.biodiversity_buffer_zone_pct,
  [GraphTileType.ndvi]: R1FactType.vegetation_condition_ndvi,
  // TODO: MVP-4772 enable when forestry is enabled
  // [GraphTileType.canopy_cover] : <actual fact type>,
  // [GraphTileType.canopy_height] <actual fact type>:,
  [GraphTileType.historic_habitat_intactness]: R1FactType.habitat_intactness_total,
  [GraphTileType.historic_habitat_intactness_threats_breakdown]: R1FactType.threat_breakdown_total,
  [GraphTileType.deforestation]: R1FactType.deforestation_occurred_since_2020,
  // TODO: MVP-8557 unhide deforestation cards for agriculture
  // [GraphTileType.historic_deforestation]: R1FactType.deforestation_total,
} as const;

export const ALL_INDICATOR_FACT_TYPES = Object.values(availableGraphsToIndicatorNames) as IndicatorFactType[];

export const INDICATORS_WITH_GRAPH_TYPE_TOGGLE: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  GraphTileType.protected_on_farm_habitat,
  GraphTileType.social_life_expectancy,
  GraphTileType.ndvi,
  GraphTileType.historic_habitat_intactness,
  GraphTileType.historic_habitat_intactness_threats_breakdown,
  // TODO: MVP-8557 unhide deforestation cards for agriculture
  // GraphTileType.historic_deforestation,
];

export const INDICATORS_WITH_ZOOM: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  GraphTileType.protected_on_farm_habitat,
  GraphTileType.social_life_expectancy,
  GraphTileType.ndvi,
];

export const INDICATORS_WITH_PER_HA_TOGGLE: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  // GraphTileType.canopy_height,
  // GraphTileType.canopy_cover,
];
